import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
import { ColumnsUser, ColumnsUserCsv } from "./columns-table";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import {
  deleteUser,
  getUsers,
  putUser,
  saveUser,
} from "services/user/user-service";
import { getCompanies } from "services/client/client-service";
import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { CSVLink } from "react-csv";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import { USER_STORAGE } from "../../../constants";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { cnpjMask } from "util/mask-cnpj";
dayjs.extend(customParseFormat);
const dateFormat = "DD/MM/YYYY";
const { confirm } = Modal;

const Users = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formRef = React.useRef(null);
  const [companies, setCompanies] = useState([]);
  const [editId, setEditId] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = React.useRef(null);
  const [selectPerfil, setSelectPerfil] = useState("USER");
  const [quantityUser, setQuantityUser] = useState(0);
  const [filterStartDate, setStartDate] = useState(null);
  const [filterEndDate, setEndDate] = useState(null);
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { role, quantityUser } = JSON.parse(localStorageItem);
      setQuantityUser(quantityUser);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, []);

  useEffect(() => {
    getData();

    getCompanies()
      .then((res) => {
        let selectCompanyRes = res.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setCompanies(selectCompanyRes);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }, []);

  function getData() {
    let obj = {
      startDate: filterStartDate,
      endDate: filterEndDate,
    };
    if (filterEndDate == null || filterStartDate == null) {
      obj = {};
    }
    getUsers(obj)
      .then((res) => {
        res = res.map((obj) => ({
          ...obj,
          disable: disable,
          edit: edit,
          activeString: obj.active ? "Ativo" : "Desativado",
          licenseBrl: obj.license?.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          }),
          profile:
            obj.role == "ADMIN"
              ? "Administrador"
              : obj.role == "USER_ADMIN"
              ? "Cliente Administrador"
              : "Cliente",
        }));
        setLoadingData(false);
        setData(res);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const showModal = () => {
    setIsModalOpen(true);
    setSelectPerfil("USER");
  };

  const handleOk = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        setLoadingData(true);
        setIsModalOpen(false);
        if (editId !== null) {
          put(values);
        } else {
          save(values);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  };
  function save(values) {
    /* if (roleRedux == ROLE_USER_ADMIN && quantityUser == data.length) {
      notificationInfo("Seu plano atingiu o limite de usuários cadastrados");
      setLoadingData(false);
      formRef.current?.resetFields();
      return;
    }*/
    if (values.document) {
      values.document = cnpjMask(values.document);
    }

    saveUser(values)
      .then(() => {
        notificationSucess();
        formRef.current?.resetFields();
        getData();
      })
      .catch((err) => {
        setLoadingData(false);
        formRef.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function put(values) {
    values.id = editId;
    if (values.document) {
      values.document = cnpjMask(values.document);
    }

    putUser(values)
      .then(() => {
        notificationSucess();
        formRef.current?.resetFields();
        getData();
      })
      .catch((err) => {
        setLoadingData(false);
        formRef.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const handleCancel = () => {
    formRef.current?.resetFields();

    setIsModalOpen(false);
  };

  function edit(row) {
    showModal();
    setEditId(row.id);
    setSelectPerfil(row.role);
    setTimeout(() => {
      formRef.current?.setFieldsValue({
        name: row.name,
        email: row.email,
        tipeUser: row.role,
        companies: row.companyCode,
        quantityUser: row.quantityUser,
        license: row.license,
        document: row.document,
      });
    }, 300);
  }
  function disable(row) {
    confirm({
      title: "Tem certeza que deseja deletar o cliente '" + row.name + "' ?",
      icon: <ExclamationCircleFilled />,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingData(true);
        deleteUser(row.id)
          .then(() => {
            notificationSucess();
            getData();
          })
          .catch((err) => {
            setLoadingData(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, tittle) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${tittle}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const setFilterStartDate = (e) => {
    if (e == null) {
      setStartDate(null);
    } else {
      setStartDate(e.format(dateFormat));
    }
  };
  const setFilterEndDate = (e) => {
    if (e == null) {
      setEndDate(null);
    } else {
      setEndDate(e.format(dateFormat));
    }
  };

  let columnFilter = ColumnsUser(roleRedux)
    .filter((item) => item.dataIndex != "action")
    .map((item) => ({
      ...item,
      ...getColumnSearchProps(item.dataIndex, item.title),
    }));
  const action = ColumnsUser(roleRedux).filter(
    (item) => item.dataIndex == "action"
  );
  columnFilter.push(action[0]);

  const refreshData = () => {
    setLoadingData(true);
    getData();
  };

  return (
    <div>
      <Row style={{ padding: "10px" }}>
        <Form layout={"inline"}>
          <Form.Item name="startDate" label="Data Inicial">
            <DatePicker
              format={dateFormat}
              allowClear={true}
              placeholder="Inicial"
              onChange={setFilterStartDate}
            />
          </Form.Item>
          <Form.Item name="endDate" label="Data Final">
            <DatePicker
              format={dateFormat}
              allowClear={true}
              placeholder="Final"
              onChange={setFilterEndDate}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" onClick={refreshData}>
              Filtrar
            </Button>
          </Form.Item>
        </Form>
      </Row>

      <div className="container-user">
        <Card
          className="card-user"
          title="Usuários"
          extra={
            <Space>
              <CSVLink
                filename={"usuarios.csv"}
                className="btn btn-primary"
                data={data}
                headers={ColumnsUserCsv(roleRedux)}
                style={{ borderRadius: "6px" }}
              >
                Baixar
              </CSVLink>
              <Button
                type="primary"
                className="button-user"
                onClick={showModal}
              >
                Novo Usuário
              </Button>
            </Space>
          }
          bordered={false}
        >
          <Spin spinning={loadingData} size={"large"}>
            <Table
              columns={columnFilter}
              dataSource={data}
              pagination={{ pageSize: 10 }}
              locale={{
                emptyText: "Sem registro",
              }}
            />
          </Spin>
        </Card>
        <Modal
          style={{ textAlign: "center" }}
          title="Novo Usuário"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Form ref={formRef} style={{ maxWidth: 600 }}>
            <Form.Item
              name="name"
              label="Nome"
              rules={[
                { required: true, message: "É necessário informar o nome" },
              ]}
            >
              <Input style={{ width: "93%", marginLeft: "15px" }} />
            </Form.Item>
            <Form.Item
              name="email"
              label="E-mail"
              rules={[
                { required: true, message: "É necessário informar o e-mail" },
              ]}
            >
              <Input style={{ width: "93%", marginLeft: "15px" }} />
            </Form.Item>
            <Form.Item
              name="password"
              label="Senha"
              rules={[
                { required: true, message: "É necessário informar a senha" },
              ]}
            >
              <Input style={{ width: "93%", marginLeft: "15px" }} />
            </Form.Item>
            {selectPerfil == "USER_ADMIN" && (
              <Form.Item
                name="document"
                label="CNPJ"
                rules={[
                  { required: true, message: "É necessário informar o cnpj" },
                ]}
              >
                <Input style={{ width: "93%", marginLeft: "15px" }} />
              </Form.Item>
            )}
            <Form.Item
              name="tipeUser"
              label="Tipo"
              rules={[
                { required: true, message: "É necessário informar o perfil" },
              ]}
            >
              <Select
                style={{ width: "91%", marginLeft: "30px" }}
                placeholder="Selecione um perfil"
                allowClear
                onChange={(event) => {
                  setSelectPerfil(event);
                }}
              >
                {roleRedux == "ADMIN" && (
                  <>
                    <Option value="ADMIN">Administrador</Option>
                    <Option value="USER">Cliente</Option>
                    <Option value="USER_ADMIN">Cliente Administrador</Option>
                  </>
                )}
                {roleRedux == "USER_ADMIN" && (
                  <>
                    <Option value="USER">Cliente</Option>
                  </>
                )}
              </Select>
            </Form.Item>
            {selectPerfil == "USER" && (
              <Form.Item
                name="companies"
                label="Empresa"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a empresa",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={companies}
                />
              </Form.Item>
            )}
            {selectPerfil == "USER_ADMIN" && (
              <Form.Item
                name="quantityUser"
                label="Usuários"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a quantidade de usuários",
                  },
                ]}
              >
                <Input
                  min={0}
                  type="number"
                  style={{ width: "93%", marginLeft: "15px" }}
                />
              </Form.Item>
            )}
            {selectPerfil == "USER_ADMIN" && (
              <Form.Item
                name="license"
                label="Licença"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar o valor da licença",
                  },
                ]}
              >
                <InputNumber
                  decimalSeparator=","
                  precision={2}
                  formatter={(value) => `R$ ${value}`}
                  parser={(value) => value.replace(/R\$\s?/, "")}
                  style={{ width: "92%", marginLeft: "20px" }}
                />
              </Form.Item>
            )}
          </Form>
        </Modal>
      </div>
    </div>
  );
};
export default Users;
